export default __webpack_public_path__ + "media/images/gartenheim-601fba44fd5c16500ef654ad31699b65.png";